module.exports = __webpack_public_path__ + "img/sy_2.8dbe9462.png";